var App = App || {};

App.InformationPresentationBand = (function ($) {
    "use strict";

    function init() {
        const InformationPresentationBand = $(".block.block-information-presentation-band");
        const inactiveClass = "hidden";

        if (InformationPresentationBand.length) {
            InformationPresentationBand.each(function () {
                var thisBand = $(this);
                var expandAll = thisBand.find(".btn.expand-all");
                var collapseAll = thisBand.find(".btn.collapse-all");

                expandAll.on("click", function () {
                    thisBand.find(".collapse").collapse('show'); 
                    expandAll.addClass(inactiveClass);
                    collapseAll.removeClass(inactiveClass);
                });

                collapseAll.on("click", function () {
                    thisBand.find(".collapse").collapse('hide'); 
                    collapseAll.addClass(inactiveClass);
                    expandAll.removeClass(inactiveClass);
                });
            });
        }
    }

    return {
        init: init
    };

})(jQuery);

$(function () {
    App.InformationPresentationBand.init();
});